unit View.Clientes.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  WEBLib.Grids, WEBLib.Lists, Grid.Plugins, System.StrUtils,
  UFrameFinanceiroCliente, Vcl.Forms, UHelperServer;

type
  TFViewClientesEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbrazao_social_nome: TLabel;
    edrazao_social_nome: TDBEdit;
    lbnome_fantasia_apelido: TLabel;
    ednome_fantasia_apelido: TDBEdit;
    lbcpf_cnpj: TLabel;
    edcpf_cnpj: TDBEdit;
    lbrg_ie: TLabel;
    edrg_ie: TDBEdit;
    lbis_pj: TLabel;
    lbcadastro: TLabel;
    edcadastro: TDBEdit;
    lbstatus: TLabel;
    edstatus: TDBEdit;
    lbemail: TLabel;
    edemail: TDBEdit;
    lbendereco: TLabel;
    edendereco: TDBEdit;
    lbcep: TLabel;
    edcep: TDBEdit;
    lbcidade_id: TLabel;
    edcidade_id: TDBEdit;
    lbtelefones: TLabel;
    edtelefones: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientClientesGet: TXDataWebClient;
    ClientesDataset: TXDataWebDataSet;
    ClientesDatasetid: TIntegerField;
    ClientesDatasetaliado_id: TIntegerField;
    ClientesDatasetdata_base_id: TIntegerField;
    ClientesDatasetrazao_social_nome: TStringField;
    ClientesDatasetnome_fantasia_apelido: TStringField;
    ClientesDatasetcpf_cnpj: TStringField;
    ClientesDatasetrg_ie: TStringField;
    ClientesDatasetis_pj: TBooleanField;
    ClientesDatasetcadastro: TDateTimeField;
    ClientesDatasetstatus: TIntegerField;
    ClientesDatasetemail: TStringField;
    ClientesDatasetendereco: TStringField;
    ClientesDatasetnumero: TStringField;
    ClientesDatasetbairro: TStringField;
    ClientesDatasetcomplemento: TStringField;
    ClientesDatasetcep: TStringField;
    ClientesDatasetcidade_id: TIntegerField;
    ClientesDatasettelefones: TStringField;
    ClientesDatasetcodigo_interno: TIntegerField;
    ClientesDatasetexcluido: TBooleanField;
    ClientesDatasetinclusao: TDateTimeField;
    ClientesDatasetalteracao: TDateTimeField;
    ClientesDatasetexclusao: TDateTimeField;
    cbxexcluido: TDBCheckBox;
    cbxpessoa_juridica: TDBCheckBox;
    ClientesDatasetcidadeNome: TStringField;
    ClientesDatasetcidadeufSigla: TStringField;
    btnFinanceiroTab: TButton;
    frmFinanceiro: TfrmFinanceiroCliente;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientClientesGetLoad(Response: TXDataClientResponse);
    procedure ClientesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure ClientesDatasetcpf_cnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetstatusGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetenderecoGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasettelefonesGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure ClientesDatasetcidadeNomeGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure btnFinanceiroTabClick(Sender: TObject);
    procedure cdsDebitosparcelaGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginDebitos : TGridPlugin;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewClientesEdit: TFViewClientesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewClientesEdit }

class function TFViewClientesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewClientesEdit.InsertEntity;
begin
  ClientesDataset.Close;
  ClientesDataset.SetJsonData('{}');
  ClientesDataset.Open;
  ClientesDataset.Insert;
end;

class function TFViewClientesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewClientesEdit(AForm).FInserting := AInserting;
    TFViewClientesEdit(AForm).FId := AId;
    TFViewClientesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewClientesEdit(AForm).InsertEntity
    else
      TFViewClientesEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewClientesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewClientesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ClientesDataset.Connection.Model.DefaultSchema.FindEntityType(
      ClientesDataset.EntitySetName
    )
  );
  XDataClientClientesGet.Get(ClientesDataset.EntitySetName, QueryString + ',cidade/uf', FId);
end;

procedure TFViewClientesEdit.XDataClientClientesGetLoad(Response: TXDataClientResponse);
begin
  ClientesDataset.Close;
  ClientesDataset.SetJsonData(Response.Result);
  ClientesDataset.Open;
  
  ClientesDataset.Edit;  
end;

procedure TFViewClientesEdit.btnFinanceiroTabClick(Sender: TObject);
begin
  if btnFinanceiroTab.Tag = 1 then
    Exit;

  frmFinanceiro.CarregarInformacoesIniciais(edid.Text);
  btnFinanceiroTab.Tag := 1;
end;

procedure TFViewClientesEdit.cdsDebitosparcelaGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := Format('%.3d', [Sender.AsInteger]);
end;

procedure TFViewClientesEdit.ClientesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewClientesEdit.ClientesDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewClientesEdit.ClientesDatasetcidadeNomeGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, ClientesDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewClientesEdit.ClientesDatasetcpf_cnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewClientesEdit.ClientesDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewClientesEdit.ClientesDatasetenderecoGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(ClientesDataset.FieldByName('endereco').AsString,
    ClientesDataset.FieldByName('numero').AsString, ClientesDataset.FieldByName('bairro').AsString,
      ClientesDataset.FieldByName('complemento').AsString, False);
end;

procedure TFViewClientesEdit.ClientesDatasetstatusGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.GetNomeStatusCliente(Sender.AsInteger);
end;

procedure TFViewClientesEdit.ClientesDatasettelefonesGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTodosTelefonesJson(Sender.AsString);
end;

procedure TFViewClientesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewClientesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.clientes.form.lbid');
  lbrazao_social_nome := TLabel.Create('view.clientes.form.lbrazao_social_nome');
  lbnome_fantasia_apelido := TLabel.Create('view.clientes.form.lbnome_fantasia_apelido');
  lbcpf_cnpj := TLabel.Create('view.clientes.form.lbcpf_cnpj');
  lbrg_ie := TLabel.Create('view.clientes.form.lbrg_ie');
  lbis_pj := TLabel.Create('view.clientes.form.lbis_pj');
  lbcadastro := TLabel.Create('view.clientes.form.lbcadastro');
  lbstatus := TLabel.Create('view.clientes.form.lbstatus');
  lbemail := TLabel.Create('view.clientes.form.lbemail');
  lbendereco := TLabel.Create('view.clientes.form.lbendereco');
  lbcep := TLabel.Create('view.clientes.form.lbcep');
  lbcidade_id := TLabel.Create('view.clientes.form.lbcidade_id');
  lbtelefones := TLabel.Create('view.clientes.form.lbtelefones');
  lbcodigo_interno := TLabel.Create('view.clientes.form.lbcodigo_interno');
  lbexcluido := TLabel.Create('view.clientes.form.lbexcluido');
  lbinclusao := TLabel.Create('view.clientes.form.lbinclusao');
  lbalteracao := TLabel.Create('view.clientes.form.lbalteracao');
  lbexclusao := TLabel.Create('view.clientes.form.lbexclusao');
  btCancel := TButton.Create('view.clientes.form.btBack');
  edid := TDBEdit.Create('view.clientes.form.edid');
  edrazao_social_nome := TDBEdit.Create('view.clientes.form.edrazao_social_nome');
  ednome_fantasia_apelido := TDBEdit.Create('view.clientes.form.ednome_fantasia_apelido');
  edcpf_cnpj := TDBEdit.Create('view.clientes.form.edcpf_cnpj');
  edrg_ie := TDBEdit.Create('view.clientes.form.edrg_ie');
  edcadastro := TDBEdit.Create('view.clientes.form.edcadastro');
  edstatus := TDBEdit.Create('view.clientes.form.edstatus');
  edemail := TDBEdit.Create('view.clientes.form.edemail');
  edendereco := TDBEdit.Create('view.clientes.form.edendereco');
  edcep := TDBEdit.Create('view.clientes.form.edcep');
  edcidade_id := TDBEdit.Create('view.clientes.form.edcidade_id');
  edtelefones := TDBEdit.Create('view.clientes.form.edtelefones');
  edcodigo_interno := TDBEdit.Create('view.clientes.form.edcodigo_interno');
  edinclusao := TDBEdit.Create('view.clientes.form.edinclusao');
  edalteracao := TDBEdit.Create('view.clientes.form.edalteracao');
  edexclusao := TDBEdit.Create('view.clientes.form.edexclusao');
  cbxexcluido := TDBCheckBox.Create('view.clientes.form.cbxexcluido');
  cbxpessoa_juridica := TDBCheckBox.Create('view.clientes.form.cbxpessoa_juridica');
  btnFinanceiroTab := TButton.Create('line-financeiro-tab');
  frmFinanceiro := TfrmFinanceiroCliente.Create(Self);
  DataSource := TDataSource.Create(Self);
  ClientesDataset := TXDataWebDataSet.Create(Self);
  ClientesDatasetid := TIntegerField.Create(Self);
  ClientesDatasetaliado_id := TIntegerField.Create(Self);
  ClientesDatasetdata_base_id := TIntegerField.Create(Self);
  ClientesDatasetrazao_social_nome := TStringField.Create(Self);
  ClientesDatasetnome_fantasia_apelido := TStringField.Create(Self);
  ClientesDatasetcpf_cnpj := TStringField.Create(Self);
  ClientesDatasetrg_ie := TStringField.Create(Self);
  ClientesDatasetis_pj := TBooleanField.Create(Self);
  ClientesDatasetcadastro := TDateTimeField.Create(Self);
  ClientesDatasetstatus := TIntegerField.Create(Self);
  ClientesDatasetemail := TStringField.Create(Self);
  ClientesDatasetendereco := TStringField.Create(Self);
  ClientesDatasetnumero := TStringField.Create(Self);
  ClientesDatasetbairro := TStringField.Create(Self);
  ClientesDatasetcomplemento := TStringField.Create(Self);
  ClientesDatasetcep := TStringField.Create(Self);
  ClientesDatasetcidade_id := TIntegerField.Create(Self);
  ClientesDatasettelefones := TStringField.Create(Self);
  ClientesDatasetcodigo_interno := TIntegerField.Create(Self);
  ClientesDatasetexcluido := TBooleanField.Create(Self);
  ClientesDatasetinclusao := TDateTimeField.Create(Self);
  ClientesDatasetalteracao := TDateTimeField.Create(Self);
  ClientesDatasetexclusao := TDateTimeField.Create(Self);
  ClientesDatasetcidadeNome := TStringField.Create(Self);
  ClientesDatasetcidadeufSigla := TStringField.Create(Self);
  XDataClientClientesGet := TXDataWebClient.Create(Self);

  frmFinanceiro.LoadFromForm;
  lbid.BeforeLoadDFMValues;
  lbrazao_social_nome.BeforeLoadDFMValues;
  lbnome_fantasia_apelido.BeforeLoadDFMValues;
  lbcpf_cnpj.BeforeLoadDFMValues;
  lbrg_ie.BeforeLoadDFMValues;
  lbis_pj.BeforeLoadDFMValues;
  lbcadastro.BeforeLoadDFMValues;
  lbstatus.BeforeLoadDFMValues;
  lbemail.BeforeLoadDFMValues;
  lbendereco.BeforeLoadDFMValues;
  lbcep.BeforeLoadDFMValues;
  lbcidade_id.BeforeLoadDFMValues;
  lbtelefones.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edrazao_social_nome.BeforeLoadDFMValues;
  ednome_fantasia_apelido.BeforeLoadDFMValues;
  edcpf_cnpj.BeforeLoadDFMValues;
  edrg_ie.BeforeLoadDFMValues;
  edcadastro.BeforeLoadDFMValues;
  edstatus.BeforeLoadDFMValues;
  edemail.BeforeLoadDFMValues;
  edendereco.BeforeLoadDFMValues;
  edcep.BeforeLoadDFMValues;
  edcidade_id.BeforeLoadDFMValues;
  edtelefones.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbxexcluido.BeforeLoadDFMValues;
  cbxpessoa_juridica.BeforeLoadDFMValues;
  btnFinanceiroTab.BeforeLoadDFMValues;
  frmFinanceiro.BeforeLoadDFMValues;
  frmFinanceiro.lbPaginationInfoDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosAVencer.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosVencidos.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblUltimaCompra.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalCompras.BeforeLoadDFMValues;
  frmFinanceiro.lblQuantidadeCompras.BeforeLoadDFMValues;
  frmFinanceiro.XDataClientResumoFinanceiro.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ClientesDataset.BeforeLoadDFMValues;
  ClientesDatasetid.BeforeLoadDFMValues;
  ClientesDatasetaliado_id.BeforeLoadDFMValues;
  ClientesDatasetdata_base_id.BeforeLoadDFMValues;
  ClientesDatasetrazao_social_nome.BeforeLoadDFMValues;
  ClientesDatasetnome_fantasia_apelido.BeforeLoadDFMValues;
  ClientesDatasetcpf_cnpj.BeforeLoadDFMValues;
  ClientesDatasetrg_ie.BeforeLoadDFMValues;
  ClientesDatasetis_pj.BeforeLoadDFMValues;
  ClientesDatasetcadastro.BeforeLoadDFMValues;
  ClientesDatasetstatus.BeforeLoadDFMValues;
  ClientesDatasetemail.BeforeLoadDFMValues;
  ClientesDatasetendereco.BeforeLoadDFMValues;
  ClientesDatasetnumero.BeforeLoadDFMValues;
  ClientesDatasetbairro.BeforeLoadDFMValues;
  ClientesDatasetcomplemento.BeforeLoadDFMValues;
  ClientesDatasetcep.BeforeLoadDFMValues;
  ClientesDatasetcidade_id.BeforeLoadDFMValues;
  ClientesDatasettelefones.BeforeLoadDFMValues;
  ClientesDatasetcodigo_interno.BeforeLoadDFMValues;
  ClientesDatasetexcluido.BeforeLoadDFMValues;
  ClientesDatasetinclusao.BeforeLoadDFMValues;
  ClientesDatasetalteracao.BeforeLoadDFMValues;
  ClientesDatasetexclusao.BeforeLoadDFMValues;
  ClientesDatasetcidadeNome.BeforeLoadDFMValues;
  ClientesDatasetcidadeufSigla.BeforeLoadDFMValues;
  XDataClientClientesGet.BeforeLoadDFMValues;
  try
    Name := 'FViewClientesEdit';
    Width := 593;
    Height := 603;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 16;
    lbid.Top := 7;
    lbid.Width := 52;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd. Serv:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbrazao_social_nome.SetParentComponent(Self);
    lbrazao_social_nome.Name := 'lbrazao_social_nome';
    lbrazao_social_nome.Left := 16;
    lbrazao_social_nome.Top := 33;
    lbrazao_social_nome.Width := 95;
    lbrazao_social_nome.Height := 13;
    lbrazao_social_nome.Caption := 'Nome/Raz'#227'o Social:';
    lbrazao_social_nome.HeightPercent := 100.000000000000000000;
    lbrazao_social_nome.WidthPercent := 100.000000000000000000;
    lbnome_fantasia_apelido.SetParentComponent(Self);
    lbnome_fantasia_apelido.Name := 'lbnome_fantasia_apelido';
    lbnome_fantasia_apelido.Left := 16;
    lbnome_fantasia_apelido.Top := 60;
    lbnome_fantasia_apelido.Width := 114;
    lbnome_fantasia_apelido.Height := 13;
    lbnome_fantasia_apelido.Caption := 'Apelido/Nome Fantasia:';
    lbnome_fantasia_apelido.HeightPercent := 100.000000000000000000;
    lbnome_fantasia_apelido.WidthPercent := 100.000000000000000000;
    lbcpf_cnpj.SetParentComponent(Self);
    lbcpf_cnpj.Name := 'lbcpf_cnpj';
    lbcpf_cnpj.Left := 16;
    lbcpf_cnpj.Top := 87;
    lbcpf_cnpj.Width := 58;
    lbcpf_cnpj.Height := 13;
    lbcpf_cnpj.Caption := 'Documento:';
    lbcpf_cnpj.HeightPercent := 100.000000000000000000;
    lbcpf_cnpj.WidthPercent := 100.000000000000000000;
    lbrg_ie.SetParentComponent(Self);
    lbrg_ie.Name := 'lbrg_ie';
    lbrg_ie.Left := 16;
    lbrg_ie.Top := 114;
    lbrg_ie.Width := 32;
    lbrg_ie.Height := 13;
    lbrg_ie.Caption := 'RG/IE:';
    lbrg_ie.HeightPercent := 100.000000000000000000;
    lbrg_ie.WidthPercent := 100.000000000000000000;
    lbis_pj.SetParentComponent(Self);
    lbis_pj.Name := 'lbis_pj';
    lbis_pj.Left := 16;
    lbis_pj.Top := 141;
    lbis_pj.Width := 78;
    lbis_pj.Height := 13;
    lbis_pj.Caption := 'Pessoa Jur'#237'dica?';
    lbis_pj.HeightPercent := 100.000000000000000000;
    lbis_pj.WidthPercent := 100.000000000000000000;
    lbcadastro.SetParentComponent(Self);
    lbcadastro.Name := 'lbcadastro';
    lbcadastro.Left := 16;
    lbcadastro.Top := 168;
    lbcadastro.Width := 48;
    lbcadastro.Height := 13;
    lbcadastro.Caption := 'Cadastro:';
    lbcadastro.HeightPercent := 100.000000000000000000;
    lbcadastro.WidthPercent := 100.000000000000000000;
    lbstatus.SetParentComponent(Self);
    lbstatus.Name := 'lbstatus';
    lbstatus.Left := 16;
    lbstatus.Top := 195;
    lbstatus.Width := 35;
    lbstatus.Height := 13;
    lbstatus.Caption := 'Status:';
    lbstatus.HeightPercent := 100.000000000000000000;
    lbstatus.WidthPercent := 100.000000000000000000;
    lbemail.SetParentComponent(Self);
    lbemail.Name := 'lbemail';
    lbemail.Left := 16;
    lbemail.Top := 222;
    lbemail.Width := 28;
    lbemail.Height := 13;
    lbemail.Caption := 'Email:';
    lbemail.HeightPercent := 100.000000000000000000;
    lbemail.WidthPercent := 100.000000000000000000;
    lbendereco.SetParentComponent(Self);
    lbendereco.Name := 'lbendereco';
    lbendereco.Left := 16;
    lbendereco.Top := 249;
    lbendereco.Width := 49;
    lbendereco.Height := 13;
    lbendereco.Caption := 'Endere'#231'o:';
    lbendereco.HeightPercent := 100.000000000000000000;
    lbendereco.WidthPercent := 100.000000000000000000;
    lbcep.SetParentComponent(Self);
    lbcep.Name := 'lbcep';
    lbcep.Left := 272;
    lbcep.Top := 7;
    lbcep.Width := 23;
    lbcep.Height := 13;
    lbcep.Caption := 'Cep:';
    lbcep.HeightPercent := 100.000000000000000000;
    lbcep.WidthPercent := 100.000000000000000000;
    lbcidade_id.SetParentComponent(Self);
    lbcidade_id.Name := 'lbcidade_id';
    lbcidade_id.Left := 272;
    lbcidade_id.Top := 34;
    lbcidade_id.Width := 37;
    lbcidade_id.Height := 13;
    lbcidade_id.Caption := 'Cidade:';
    lbcidade_id.HeightPercent := 100.000000000000000000;
    lbcidade_id.WidthPercent := 100.000000000000000000;
    lbtelefones.SetParentComponent(Self);
    lbtelefones.Name := 'lbtelefones';
    lbtelefones.Left := 272;
    lbtelefones.Top := 61;
    lbtelefones.Width := 51;
    lbtelefones.Height := 13;
    lbtelefones.Caption := 'Telefones:';
    lbtelefones.HeightPercent := 100.000000000000000000;
    lbtelefones.WidthPercent := 100.000000000000000000;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 272;
    lbcodigo_interno.Top := 88;
    lbcodigo_interno.Width := 47;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'C'#243'd. Ret:';
    lbcodigo_interno.HeightPercent := 100.000000000000000000;
    lbcodigo_interno.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 272;
    lbexcluido.Top := 115;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 272;
    lbinclusao.Top := 142;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 272;
    lbalteracao.Top := 169;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 272;
    lbexclusao.Top := 196;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 365;
    btCancel.Top := 220;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 133;
    edid.Top := 4;
    edid.Width := 130;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edrazao_social_nome.SetParentComponent(Self);
    edrazao_social_nome.Name := 'edrazao_social_nome';
    edrazao_social_nome.Left := 133;
    edrazao_social_nome.Top := 30;
    edrazao_social_nome.Width := 130;
    edrazao_social_nome.Height := 21;
    edrazao_social_nome.Enabled := False;
    edrazao_social_nome.HeightPercent := 100.000000000000000000;
    edrazao_social_nome.TabOrder := 9;
    edrazao_social_nome.Text := 'edrazao_social_nome';
    edrazao_social_nome.WidthPercent := 100.000000000000000000;
    edrazao_social_nome.DataField := 'razao_social_nome';
    edrazao_social_nome.DataSource := DataSource;
    ednome_fantasia_apelido.SetParentComponent(Self);
    ednome_fantasia_apelido.Name := 'ednome_fantasia_apelido';
    ednome_fantasia_apelido.Left := 133;
    ednome_fantasia_apelido.Top := 57;
    ednome_fantasia_apelido.Width := 130;
    ednome_fantasia_apelido.Height := 21;
    ednome_fantasia_apelido.Enabled := False;
    ednome_fantasia_apelido.HeightPercent := 100.000000000000000000;
    ednome_fantasia_apelido.TabOrder := 10;
    ednome_fantasia_apelido.Text := 'ednome_fantasia_apelido';
    ednome_fantasia_apelido.WidthPercent := 100.000000000000000000;
    ednome_fantasia_apelido.DataField := 'nome_fantasia_apelido';
    ednome_fantasia_apelido.DataSource := DataSource;
    edcpf_cnpj.SetParentComponent(Self);
    edcpf_cnpj.Name := 'edcpf_cnpj';
    edcpf_cnpj.Left := 133;
    edcpf_cnpj.Top := 84;
    edcpf_cnpj.Width := 130;
    edcpf_cnpj.Height := 21;
    edcpf_cnpj.Enabled := False;
    edcpf_cnpj.HeightPercent := 100.000000000000000000;
    edcpf_cnpj.TabOrder := 11;
    edcpf_cnpj.Text := 'edcpf_cnpj';
    edcpf_cnpj.WidthPercent := 100.000000000000000000;
    edcpf_cnpj.DataField := 'cpf_cnpj';
    edcpf_cnpj.DataSource := DataSource;
    edrg_ie.SetParentComponent(Self);
    edrg_ie.Name := 'edrg_ie';
    edrg_ie.Left := 133;
    edrg_ie.Top := 111;
    edrg_ie.Width := 130;
    edrg_ie.Height := 21;
    edrg_ie.Enabled := False;
    edrg_ie.HeightPercent := 100.000000000000000000;
    edrg_ie.TabOrder := 12;
    edrg_ie.Text := 'edrg_ie';
    edrg_ie.WidthPercent := 100.000000000000000000;
    edrg_ie.DataField := 'rg_ie';
    edrg_ie.DataSource := DataSource;
    edcadastro.SetParentComponent(Self);
    edcadastro.Name := 'edcadastro';
    edcadastro.Left := 133;
    edcadastro.Top := 165;
    edcadastro.Width := 130;
    edcadastro.Height := 21;
    edcadastro.Enabled := False;
    edcadastro.HeightPercent := 100.000000000000000000;
    edcadastro.TabOrder := 14;
    edcadastro.Text := 'edcadastro';
    edcadastro.WidthPercent := 100.000000000000000000;
    edcadastro.DataField := 'cadastro';
    edcadastro.DataSource := DataSource;
    edstatus.SetParentComponent(Self);
    edstatus.Name := 'edstatus';
    edstatus.Left := 133;
    edstatus.Top := 192;
    edstatus.Width := 130;
    edstatus.Height := 21;
    edstatus.Enabled := False;
    edstatus.HeightPercent := 100.000000000000000000;
    edstatus.TabOrder := 15;
    edstatus.Text := 'edstatus';
    edstatus.WidthPercent := 100.000000000000000000;
    edstatus.DataField := 'status';
    edstatus.DataSource := DataSource;
    edemail.SetParentComponent(Self);
    edemail.Name := 'edemail';
    edemail.Left := 133;
    edemail.Top := 219;
    edemail.Width := 130;
    edemail.Height := 21;
    edemail.Enabled := False;
    edemail.HeightPercent := 100.000000000000000000;
    edemail.TabOrder := 16;
    edemail.Text := 'edemail';
    edemail.WidthPercent := 100.000000000000000000;
    edemail.DataField := 'email';
    edemail.DataSource := DataSource;
    edendereco.SetParentComponent(Self);
    edendereco.Name := 'edendereco';
    edendereco.Left := 133;
    edendereco.Top := 246;
    edendereco.Width := 130;
    edendereco.Height := 21;
    edendereco.Enabled := False;
    edendereco.HeightPercent := 100.000000000000000000;
    edendereco.TabOrder := 17;
    edendereco.Text := 'edendereco';
    edendereco.WidthPercent := 100.000000000000000000;
    edendereco.DataField := 'endereco';
    edendereco.DataSource := DataSource;
    edcep.SetParentComponent(Self);
    edcep.Name := 'edcep';
    edcep.Left := 365;
    edcep.Top := 4;
    edcep.Width := 130;
    edcep.Height := 21;
    edcep.Enabled := False;
    edcep.HeightPercent := 100.000000000000000000;
    edcep.TabOrder := 21;
    edcep.Text := 'edcep';
    edcep.WidthPercent := 100.000000000000000000;
    edcep.DataField := 'cep';
    edcep.DataSource := DataSource;
    edcidade_id.SetParentComponent(Self);
    edcidade_id.Name := 'edcidade_id';
    edcidade_id.Left := 365;
    edcidade_id.Top := 31;
    edcidade_id.Width := 130;
    edcidade_id.Height := 21;
    edcidade_id.Enabled := False;
    edcidade_id.HeightPercent := 100.000000000000000000;
    edcidade_id.TabOrder := 22;
    edcidade_id.Text := 'edcidade_id';
    edcidade_id.WidthPercent := 100.000000000000000000;
    edcidade_id.DataField := 'cidade.Nome';
    edcidade_id.DataSource := DataSource;
    edtelefones.SetParentComponent(Self);
    edtelefones.Name := 'edtelefones';
    edtelefones.Left := 365;
    edtelefones.Top := 58;
    edtelefones.Width := 130;
    edtelefones.Height := 21;
    edtelefones.Enabled := False;
    edtelefones.HeightPercent := 100.000000000000000000;
    edtelefones.TabOrder := 23;
    edtelefones.Text := 'edtelefones';
    edtelefones.WidthPercent := 100.000000000000000000;
    edtelefones.DataField := 'telefones';
    edtelefones.DataSource := DataSource;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 365;
    edcodigo_interno.Top := 85;
    edcodigo_interno.Width := 130;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := False;
    edcodigo_interno.HeightPercent := 100.000000000000000000;
    edcodigo_interno.TabOrder := 24;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.WidthPercent := 100.000000000000000000;
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 365;
    edinclusao.Top := 139;
    edinclusao.Width := 130;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 26;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 365;
    edalteracao.Top := 166;
    edalteracao.Width := 130;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 27;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 365;
    edexclusao.Top := 193;
    edexclusao.Width := 130;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 28;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbxexcluido.SetParentComponent(Self);
    cbxexcluido.Name := 'cbxexcluido';
    cbxexcluido.Left := 365;
    cbxexcluido.Top := 111;
    cbxexcluido.Width := 130;
    cbxexcluido.Height := 22;
    cbxexcluido.Caption := 'cbxexcluido';
    cbxexcluido.ChildOrder := 33;
    cbxexcluido.Enabled := False;
    cbxexcluido.HeightPercent := 100.000000000000000000;
    cbxexcluido.WidthPercent := 100.000000000000000000;
    cbxexcluido.DataField := 'excluido';
    cbxexcluido.DataSource := DataSource;
    cbxpessoa_juridica.SetParentComponent(Self);
    cbxpessoa_juridica.Name := 'cbxpessoa_juridica';
    cbxpessoa_juridica.Left := 133;
    cbxpessoa_juridica.Top := 138;
    cbxpessoa_juridica.Width := 130;
    cbxpessoa_juridica.Height := 22;
    cbxpessoa_juridica.Caption := 'cbxpessoa_juridica';
    cbxpessoa_juridica.ChildOrder := 33;
    cbxpessoa_juridica.Enabled := False;
    cbxpessoa_juridica.HeightPercent := 100.000000000000000000;
    cbxpessoa_juridica.WidthPercent := 100.000000000000000000;
    cbxpessoa_juridica.DataField := 'is_pj';
    cbxpessoa_juridica.DataSource := DataSource;
    btnFinanceiroTab.SetParentComponent(Self);
    btnFinanceiroTab.Name := 'btnFinanceiroTab';
    btnFinanceiroTab.Left := 365;
    btnFinanceiroTab.Top := 251;
    btnFinanceiroTab.Width := 96;
    btnFinanceiroTab.Height := 25;
    btnFinanceiroTab.Caption := 'Financeiro';
    btnFinanceiroTab.ChildOrder := 16;
    btnFinanceiroTab.HeightPercent := 100.000000000000000000;
    btnFinanceiroTab.TabStop := False;
    btnFinanceiroTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnFinanceiroTab, Self, 'OnClick', 'btnFinanceiroTabClick');
    frmFinanceiro.SetParentComponent(Self);
    frmFinanceiro.Name := 'frmFinanceiro';
    frmFinanceiro.Left := 8;
    frmFinanceiro.Top := 344;
    frmFinanceiro.Width := 564;
    frmFinanceiro.Height := 241;
    frmFinanceiro.TabOrder := 20;
    frmFinanceiro.Visible := False;
    frmFinanceiro.lbPaginationInfoDebitos.Width := 141;
    frmFinanceiro.lbPaginationInfoDebitos.Height := 13;
    frmFinanceiro.lblDebitosAVencer.Width := 4;
    frmFinanceiro.lblDebitosAVencer.Height := 13;
    frmFinanceiro.lblDebitosVencidos.Width := 4;
    frmFinanceiro.lblDebitosVencidos.Height := 13;
    frmFinanceiro.lblTotalDebitos.Width := 4;
    frmFinanceiro.lblTotalDebitos.Height := 13;
    frmFinanceiro.lblUltimaCompra.Width := 4;
    frmFinanceiro.lblUltimaCompra.Height := 13;
    frmFinanceiro.lblTotalCompras.Width := 4;
    frmFinanceiro.lblTotalCompras.Height := 13;
    frmFinanceiro.lblQuantidadeCompras.Width := 4;
    frmFinanceiro.lblQuantidadeCompras.Height := 13;
    SetEvent(frmFinanceiro.XDataClientResumoFinanceiro, Self, 'OnLoad', 'nil');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ClientesDataset;
    DataSource.Left := 240;
    DataSource.Top := 280;
    ClientesDataset.SetParentComponent(Self);
    ClientesDataset.Name := 'ClientesDataset';
    ClientesDataset.AfterApplyUpdates := ClientesDatasetAfterApplyUpdates;
    ClientesDataset.EntitySetName := 'Clientes';
    ClientesDataset.Connection := DMConnection.ApiConnection;
    ClientesDataset.Left := 160;
    ClientesDataset.Top := 280;
    ClientesDatasetid.SetParentComponent(ClientesDataset);
    ClientesDatasetid.Name := 'ClientesDatasetid';
    ClientesDatasetid.FieldName := 'id';
    ClientesDatasetid.Required := True;
    ClientesDatasetaliado_id.SetParentComponent(ClientesDataset);
    ClientesDatasetaliado_id.Name := 'ClientesDatasetaliado_id';
    ClientesDatasetaliado_id.FieldName := 'aliado_id';
    ClientesDatasetaliado_id.Required := True;
    ClientesDatasetdata_base_id.SetParentComponent(ClientesDataset);
    ClientesDatasetdata_base_id.Name := 'ClientesDatasetdata_base_id';
    ClientesDatasetdata_base_id.FieldName := 'data_base_id';
    ClientesDatasetdata_base_id.Required := True;
    ClientesDatasetrazao_social_nome.SetParentComponent(ClientesDataset);
    ClientesDatasetrazao_social_nome.Name := 'ClientesDatasetrazao_social_nome';
    ClientesDatasetrazao_social_nome.FieldName := 'razao_social_nome';
    ClientesDatasetrazao_social_nome.Required := True;
    ClientesDatasetrazao_social_nome.Size := 255;
    ClientesDatasetnome_fantasia_apelido.SetParentComponent(ClientesDataset);
    ClientesDatasetnome_fantasia_apelido.Name := 'ClientesDatasetnome_fantasia_apelido';
    ClientesDatasetnome_fantasia_apelido.FieldName := 'nome_fantasia_apelido';
    ClientesDatasetnome_fantasia_apelido.Size := 255;
    ClientesDatasetcpf_cnpj.SetParentComponent(ClientesDataset);
    ClientesDatasetcpf_cnpj.Name := 'ClientesDatasetcpf_cnpj';
    ClientesDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    SetEvent(ClientesDatasetcpf_cnpj, Self, 'OnGetText', 'ClientesDatasetcpf_cnpjGetText');
    ClientesDatasetcpf_cnpj.Size := 255;
    ClientesDatasetrg_ie.SetParentComponent(ClientesDataset);
    ClientesDatasetrg_ie.Name := 'ClientesDatasetrg_ie';
    ClientesDatasetrg_ie.FieldName := 'rg_ie';
    ClientesDatasetrg_ie.Size := 255;
    ClientesDatasetis_pj.SetParentComponent(ClientesDataset);
    ClientesDatasetis_pj.Name := 'ClientesDatasetis_pj';
    ClientesDatasetis_pj.FieldName := 'is_pj';
    ClientesDatasetcadastro.SetParentComponent(ClientesDataset);
    ClientesDatasetcadastro.Name := 'ClientesDatasetcadastro';
    ClientesDatasetcadastro.FieldName := 'cadastro';
    ClientesDatasetcadastro.DisplayFormat := 'dd/mm/yy';
    ClientesDatasetstatus.SetParentComponent(ClientesDataset);
    ClientesDatasetstatus.Name := 'ClientesDatasetstatus';
    ClientesDatasetstatus.FieldName := 'status';
    ClientesDatasetstatus.Required := True;
    SetEvent(ClientesDatasetstatus, Self, 'OnGetText', 'ClientesDatasetstatusGetText');
    ClientesDatasetemail.SetParentComponent(ClientesDataset);
    ClientesDatasetemail.Name := 'ClientesDatasetemail';
    ClientesDatasetemail.FieldName := 'email';
    SetEvent(ClientesDatasetemail, Self, 'OnGetText', 'ClientesDatasetemailGetText');
    ClientesDatasetemail.Size := 255;
    ClientesDatasetendereco.SetParentComponent(ClientesDataset);
    ClientesDatasetendereco.Name := 'ClientesDatasetendereco';
    ClientesDatasetendereco.FieldName := 'endereco';
    SetEvent(ClientesDatasetendereco, Self, 'OnGetText', 'ClientesDatasetenderecoGetText');
    ClientesDatasetendereco.Size := 255;
    ClientesDatasetnumero.SetParentComponent(ClientesDataset);
    ClientesDatasetnumero.Name := 'ClientesDatasetnumero';
    ClientesDatasetnumero.FieldName := 'numero';
    ClientesDatasetnumero.Size := 255;
    ClientesDatasetbairro.SetParentComponent(ClientesDataset);
    ClientesDatasetbairro.Name := 'ClientesDatasetbairro';
    ClientesDatasetbairro.FieldName := 'bairro';
    ClientesDatasetbairro.Size := 255;
    ClientesDatasetcomplemento.SetParentComponent(ClientesDataset);
    ClientesDatasetcomplemento.Name := 'ClientesDatasetcomplemento';
    ClientesDatasetcomplemento.FieldName := 'complemento';
    ClientesDatasetcomplemento.Size := 255;
    ClientesDatasetcep.SetParentComponent(ClientesDataset);
    ClientesDatasetcep.Name := 'ClientesDatasetcep';
    ClientesDatasetcep.FieldName := 'cep';
    ClientesDatasetcep.Required := True;
    SetEvent(ClientesDatasetcep, Self, 'OnGetText', 'ClientesDatasetcepGetText');
    ClientesDatasetcep.Size := 255;
    ClientesDatasetcidade_id.SetParentComponent(ClientesDataset);
    ClientesDatasetcidade_id.Name := 'ClientesDatasetcidade_id';
    ClientesDatasetcidade_id.FieldName := 'cidade_id';
    ClientesDatasettelefones.SetParentComponent(ClientesDataset);
    ClientesDatasettelefones.Name := 'ClientesDatasettelefones';
    ClientesDatasettelefones.FieldName := 'telefones';
    ClientesDatasettelefones.Required := True;
    SetEvent(ClientesDatasettelefones, Self, 'OnGetText', 'ClientesDatasettelefonesGetText');
    ClientesDatasettelefones.Size := 255;
    ClientesDatasetcodigo_interno.SetParentComponent(ClientesDataset);
    ClientesDatasetcodigo_interno.Name := 'ClientesDatasetcodigo_interno';
    ClientesDatasetcodigo_interno.FieldName := 'codigo_interno';
    ClientesDatasetcodigo_interno.Required := True;
    ClientesDatasetexcluido.SetParentComponent(ClientesDataset);
    ClientesDatasetexcluido.Name := 'ClientesDatasetexcluido';
    ClientesDatasetexcluido.FieldName := 'excluido';
    ClientesDatasetinclusao.SetParentComponent(ClientesDataset);
    ClientesDatasetinclusao.Name := 'ClientesDatasetinclusao';
    ClientesDatasetinclusao.FieldName := 'inclusao';
    ClientesDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ClientesDatasetalteracao.SetParentComponent(ClientesDataset);
    ClientesDatasetalteracao.Name := 'ClientesDatasetalteracao';
    ClientesDatasetalteracao.FieldName := 'alteracao';
    ClientesDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ClientesDatasetexclusao.SetParentComponent(ClientesDataset);
    ClientesDatasetexclusao.Name := 'ClientesDatasetexclusao';
    ClientesDatasetexclusao.FieldName := 'exclusao';
    ClientesDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ClientesDatasetcidadeNome.SetParentComponent(ClientesDataset);
    ClientesDatasetcidadeNome.Name := 'ClientesDatasetcidadeNome';
    ClientesDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(ClientesDatasetcidadeNome, Self, 'OnGetText', 'ClientesDatasetcidadeNomeGetText');
    ClientesDatasetcidadeufSigla.SetParentComponent(ClientesDataset);
    ClientesDatasetcidadeufSigla.Name := 'ClientesDatasetcidadeufSigla';
    ClientesDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    XDataClientClientesGet.SetParentComponent(Self);
    XDataClientClientesGet.Name := 'XDataClientClientesGet';
    XDataClientClientesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientClientesGet, Self, 'OnLoad', 'XDataClientClientesGetLoad');
    XDataClientClientesGet.Left := 56;
    XDataClientClientesGet.Top := 280;
  finally
    lbid.AfterLoadDFMValues;
    lbrazao_social_nome.AfterLoadDFMValues;
    lbnome_fantasia_apelido.AfterLoadDFMValues;
    lbcpf_cnpj.AfterLoadDFMValues;
    lbrg_ie.AfterLoadDFMValues;
    lbis_pj.AfterLoadDFMValues;
    lbcadastro.AfterLoadDFMValues;
    lbstatus.AfterLoadDFMValues;
    lbemail.AfterLoadDFMValues;
    lbendereco.AfterLoadDFMValues;
    lbcep.AfterLoadDFMValues;
    lbcidade_id.AfterLoadDFMValues;
    lbtelefones.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edrazao_social_nome.AfterLoadDFMValues;
    ednome_fantasia_apelido.AfterLoadDFMValues;
    edcpf_cnpj.AfterLoadDFMValues;
    edrg_ie.AfterLoadDFMValues;
    edcadastro.AfterLoadDFMValues;
    edstatus.AfterLoadDFMValues;
    edemail.AfterLoadDFMValues;
    edendereco.AfterLoadDFMValues;
    edcep.AfterLoadDFMValues;
    edcidade_id.AfterLoadDFMValues;
    edtelefones.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbxexcluido.AfterLoadDFMValues;
    cbxpessoa_juridica.AfterLoadDFMValues;
    btnFinanceiroTab.AfterLoadDFMValues;
    frmFinanceiro.AfterLoadDFMValues;
    frmFinanceiro.lbPaginationInfoDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosAVencer.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosVencidos.AfterLoadDFMValues;
    frmFinanceiro.lblTotalDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblUltimaCompra.AfterLoadDFMValues;
    frmFinanceiro.lblTotalCompras.AfterLoadDFMValues;
    frmFinanceiro.lblQuantidadeCompras.AfterLoadDFMValues;
    frmFinanceiro.XDataClientResumoFinanceiro.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ClientesDataset.AfterLoadDFMValues;
    ClientesDatasetid.AfterLoadDFMValues;
    ClientesDatasetaliado_id.AfterLoadDFMValues;
    ClientesDatasetdata_base_id.AfterLoadDFMValues;
    ClientesDatasetrazao_social_nome.AfterLoadDFMValues;
    ClientesDatasetnome_fantasia_apelido.AfterLoadDFMValues;
    ClientesDatasetcpf_cnpj.AfterLoadDFMValues;
    ClientesDatasetrg_ie.AfterLoadDFMValues;
    ClientesDatasetis_pj.AfterLoadDFMValues;
    ClientesDatasetcadastro.AfterLoadDFMValues;
    ClientesDatasetstatus.AfterLoadDFMValues;
    ClientesDatasetemail.AfterLoadDFMValues;
    ClientesDatasetendereco.AfterLoadDFMValues;
    ClientesDatasetnumero.AfterLoadDFMValues;
    ClientesDatasetbairro.AfterLoadDFMValues;
    ClientesDatasetcomplemento.AfterLoadDFMValues;
    ClientesDatasetcep.AfterLoadDFMValues;
    ClientesDatasetcidade_id.AfterLoadDFMValues;
    ClientesDatasettelefones.AfterLoadDFMValues;
    ClientesDatasetcodigo_interno.AfterLoadDFMValues;
    ClientesDatasetexcluido.AfterLoadDFMValues;
    ClientesDatasetinclusao.AfterLoadDFMValues;
    ClientesDatasetalteracao.AfterLoadDFMValues;
    ClientesDatasetexclusao.AfterLoadDFMValues;
    ClientesDatasetcidadeNome.AfterLoadDFMValues;
    ClientesDatasetcidadeufSigla.AfterLoadDFMValues;
    XDataClientClientesGet.AfterLoadDFMValues;
  end;
end;

end.
